import { render, staticRenderFns } from "./InsurancePaymentsRegistryGroups.vue?vue&type=template&id=315287d6&"
import script from "./InsurancePaymentsRegistryGroups.vue?vue&type=script&lang=js&"
export * from "./InsurancePaymentsRegistryGroups.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports